module.exports = __webpack_public_path__ + "static/media/culture_arts-min.fa861c53.jpg";